<template>
    <v-row justify="center">
        <v-dialog max-width="500px" persistent v-model="showPopup.show">
            <v-form ref="form">
                <v-card>

                    <v-card-title class="blue">
                        <v-icon class="pa-1 mr-1" color="red lighten-1">fas fa-lock</v-icon>
                        <span class="headline">Lizenz sperren </span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-textarea label="Kommentar" v-model="comment"></v-textarea>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click="showPopup.show = false" color="blue darken-1" text>Schließen</v-btn>
                        <v-btn :loading="loading" @click="submit" color="green darken-1" text>Speichern</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
    </v-row>
</template>

<script>
    import moment from 'moment'
    import {HTTP} from "../http";
    import {EventBus} from "../eventbus";


    export default {
        props: {
            showPopup: Object,
            LicenceId: String
        },
        data() {
            return {
                comment: null,

                inputRules: [
                    v => !!v || 'Darf nicht leer sein'
                ],
                loading: false,
            }
        },
        methods: {
            submit() {
                if (this.$refs.form.validate()) {
                    this.loading = true;
                    let data = {
                        LicenceID: this.LicenceId,
                        Comment: this.comment
                    }
                    HTTP.post("api/Licence/revoke", data).then(() => {
                        this.loading = false;
                        EventBus.$emit('reload');
                        this.showPopup.show = false;

                    }).catch(() => {
                        this.loading = false;
                    })

                }
            }
        },
        computed: {
            formattedDate() {
                return this.due ? moment(this.due).format('DD MMM YYYY') : ''
            }
        }
    }
</script>
